import request from '@/utils/request'

export function qLserverLog(data) {
  return request({
    url: '/admin/serverLog/qlServerLog',
    method: 'post',
    data: data
  })


}


export function qlStoreLogType(params) {
  return request({
    url: '/admin/serverLog/qlStoreLogType',
    method: 'get',
    params: params
  })


}






// WEBPACK FOOTER //
// ./src/api/serverLog.js